import PersonCreateView from "./PersonCreateView";
import {useContext, useEffect, useState} from "react";
import PersonView from "./PersonView";
import PersonEditView from "./PersonEditView";
import {addUser, getEgo, getUser} from "../api/api";
import {useDeleteConfirmation} from "../api/API.tsx";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import queryString from 'query-string';
import {roles, sexes} from '../ToDos.js';
import {APIContext} from "../Globals.tsx";
import {storeInStorage} from "../api/LocalStorage.tsx";

// TODO: split user and users correct!false
export default function Person(){

    const {id} = useParams();
    const {edit} = queryString.parse(useLocation().search);
    const navigate = useNavigate();
    const [editing, setEditing] = useState(false);
    const [create, setCreate] = useState(id === "add");
    const [user, setUser] = useState({
        firstname: "", lastname: "", email: "",
        phone: "", birthday: "", sex: "", verified: false, ticketsMax: 0, tickets: 0, courses: [],
        contract: {repeat: "", startDate: "", endDate: ""}, address:{country: "", city: "", street: "", zip: ""},
    });
    const [contractType, setContractType] = useState(null);
    const [sex, setSex] = useState(null);
    const [contracts, setContracts] = useState(null);
    const {getContracts} = useContext(APIContext);
    const { confirmDelete, WarningModal } = useDeleteConfirmation();

    function updatePersonContract(){
        setUser(old => {
            return {
                ...user,
                "contract": {
                    repeat: contractType?.value ?? "",
                    startDate: old.contract?.startDate,
                    // endDate: new Date().toISOString().split("T")[0]
                    endDate: old.contract?.startDate ?
                        new Date(new Date(old.contract?.startDate).setMonth(new Date(old.contract?.startDate).getMonth() + (contractType?.months || 12*99))).toISOString().split("T")[0] :
                        null
                }
            };
        });
    }

    useEffect(() => {
        updatePersonContract()
    }, [contractType]);

    useEffect(() => {
        updatePersonContract();
    }, [user.contract?.startDate]);

    useEffect(() => {
        setUser({...user, "sex": sex?.value});
    }, [sex]);

    async function load(){
        let contracts_;
        contracts_ = (await getContracts())?.contracts?.map((contract) => {
                let value = !contract.repeat.includes("all_in") ? contract.repeat + "_" + contract.tickets : contract.repeat;
                return {
                    tickets: !contract.repeat.includes("all_in") ? contract.tickets : -1,
                    months: contract.months,
                    value: value,
                    label: contract.name
                };
            }
        );
        setContracts(contracts_);
        if(!id){
            getEgo().then(r => setUser(r));
        }
        else if(id !== "add"){
            if(edit === "true"){
                setEditing(true);
            }
            getUser(id).then(r => {
                setUser(r);
                storeInStorage("tmpUser", r)
                setContractType(contracts_.find(type => type.value === r.contract?.repeat));
                setSex(sexes.find(sex => sex.value === r.sex));
            });
        }
    }

    useEffect(() => {
        load();
    }, []);

    function handleChange(event){
        setUser({...user, [event.target.name]: event.target.value});
    }

    function handleChangeAddress(event){
        setUser({...user, ...{address: {...user.address, [event.target.name]: event.target.value}}});
    }

    function handleExit(){
        if(window.location.search)
            window.location.replace(window.location.pathname);
        else
            navigate(-1)
    }

    return (
        <div>
          <WarningModal/>
            {editing === false && create === false ?
                <PersonView user={user}
                            handleEdit={() => {
                                setEditing(true);
                            }}
                            handleCreate={() => {
                                setCreate(true);
                            }}
                            setEditing={setEditing}
                            updateEgo={() => {
                                addUser(user).then((e) => {
                                    if(e !== null){
                                        window.location.replace(window.location.pathname);
                                    }
                                });
                            }}
                            contracts={contracts}
                            setUser={setUser}
                            setContractType={setContractType}
                            contractType={contractType}
                            handleChange={(auth)=>{
                              if(auth < 0 || auth > 1 || auth === user.authLevel || user.authLevel > 1)
                                return
                              confirmDelete(`Willst du ${user.firstname} wirklich von "${roles[user.authLevel + 1].label}" auf "${roles[auth + 1].label}" ändern?`).then((confirmed)=>{
                                if (!confirmed) {
                                  return;
                                }
                                let user_ = ({...user, "authLevel": auth});
                                addUser(user_).then((e) => {
                                  if(e !== null){
                                    window.location.replace(window.location.pathname);
                                  }
                                });
                              })
                            }}
                /> :
                editing === true ?
                    <PersonEditView user={user}
                                    handleChange={handleChange}
                                    updateEgo={() => {
                                        addUser(user).then((e) => {
                                            if(e !== null){
                                                window.location.replace(window.location.pathname);
                                            }
                                        });
                                    }}
                                    handleExit={handleExit}
                                    setSex={setSex}
                                    sex={sex}
                                    handleChangeAddress={handleChangeAddress}
                    /> :
                    create === true ?
                        <PersonCreateView user={user}
                                          handleChange={handleChange}
                                          createEgo={() => {
                                              addUser(user).then((e) => {
                                                  if(e !== null){
                                                      navigate(-1)
                                                  }
                                              });
                                          }}
                                          handleExit={handleExit}
                                          contracts={contracts}
                                          setUser={setUser}
                                          setSex={setSex}
                                          sex={sex}
                                          contractType={contractType}
                                          setContractType={setContractType}
                        /> : null
            }
        </div>
    );
}